import "packages/frontend/core/src/desktop/dialogs/setting/account-setting/integrations-panel.css.ts.vanilla.css!=!../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"packages/frontend/core/src/desktop/dialogs/setting/account-setting/integrations-panel.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA71WwXKbMBC9-yt06UxzUAaIQ2P11j8RaMGKQWIkEex2-u8dhDHCyA4QTy9mvGjf7r59u-L5kIRV0gTozwYhxnVV0BNBWQHHnxtkn5hxBanhUhCUyqIuRfsmpxVBYVzZYxVljIucoDCqjihA29b8d_PcYYd-bFrwXGBuoNQEpSAMqNb8XmvDsxNOpTAgDEG6oingBEwD4ISORjGiRTEswluXeyaFwZr_BoLCbWcquAC8B57vDUFR5JxrzsbXIGhtqSykIuiDqu8Y0yxr_T4ibOBocKV4SdXpyUny5WtEDK8GvuOWbyfEdl0fx2S--kHmdsYrit6aSMVAYUUZr_WlCZ2VoLA6Ii0LziacFvQECnOhOYNfHUbn9GT9aXrIlawFm3aj8xxO-DoT-yt2yLlqkyVUG6qMg_LDojScmT1BL2e3Xkf9_xsELClAQyoF60p4iJ7u6dgNdqn0bZXMxmthZzE-Hb_gYeNH7zS5XwZtAY1qLe3v9X6IPAmGZ9fFHCbLV1Y8XVkrUtKGmlpjUEoqN6HUlW88Vq9_ene73efyvRWOLa-_r9bTpom67RkQzIkI61XrG_8xeDaRc-hrTbxSLfkE3tf5flrmwk-ubififhVbXQYXEL7uPhqDvM-qffUgHlzdh0Hwbc5ld_Eu7myV-P9vldKmM28zImQNDFKpaNeIWjBQbSYOpHgE_be2gJz5rTFM3NUuKKnKucBGDt8x_wDieHyB1AoAAA\"}!../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var panelHeader = 'kb1pbw1';
export var caldavField = 'kb1pbwi';
export var caldavFooter = 'kb1pbwo';
export var loading = 'kb1pbw3';
export var caldavProviderButton = 'kb1pbwk';
export var caldavHint = 'kb1pbwl';
export var caldavError = 'kb1pbwn';
export var panelTitle = 'kb1pbw2';
export var intervalLabel = 'kb1pbwf';
export var interval = 'kb1pbwe';
export var caldavLink = 'kb1pbwm';
export var accountMeta = 'kb1pbwa';
export var accountInfo = 'kb1pbw6';
export var accountName = 'kb1pbw9';
export var accountActions = 'kb1pbwd';
export var accountList = 'kb1pbw4';
export var accountIcon = 'kb1pbw7';
export var accountRow = 'kb1pbw5';
export var accountStatus = 'kb1pbwb';
export var caldavLabel = 'kb1pbwj';
export var caldavDialog = 'kb1pbwh';
export var empty = 'kb1pbwg';
export var accountDetails = 'kb1pbw8';
export var panel = 'kb1pbw0';
export var statusDot = 'kb1pbwc';